module.exports = __webpack_public_path__ + "static/media/Halcyon_dark_mode.9336be7a.png";